"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.DesignerTheme = exports.DesignerThemeBasicProfile = void 0;
var DesignerThemeBasicProfile = /** @class */ (function () {
    function DesignerThemeBasicProfile() {
    }
    /* The bright mono */
    DesignerThemeBasicProfile.defaultDesignerTheme = {
        overallDesignerBck: '#FFFFFF',
        overallDesignerContent: '#1A1A1A',
        designerPanelBck: '#E0E0E0',
        designerPanelContent: '#1A1A1A',
        designerPanelControlsActiveBck: '#1A1A1A',
        designerPanelControlsActiveContent: '#FFFFFF',
        designerPanelControlsInactiveContent: '#1A1A1A',
        fontType: 'Helvetica'
    };
    return DesignerThemeBasicProfile;
}());
exports.DesignerThemeBasicProfile = DesignerThemeBasicProfile;
var DesignerTheme = /** @class */ (function () {
    function DesignerTheme() {
    }
    DesignerTheme.themeToBasicProfile = function (designerTheme) {
        return {
            overallDesignerBck: designerTheme.viewer3d.panelBackgroundColor,
            overallDesignerContent: designerTheme.viewer3d.price.color,
            designerPanelBck: designerTheme.screen.feature.panelBackgroundColor,
            designerPanelContent: designerTheme.screen.feature.panelTitle.color,
            designerPanelControlsActiveBck: designerTheme.screen.feature.button.selectedState.backgroundColor,
            designerPanelControlsActiveContent: designerTheme.screen.feature.button.selectedState.text.color,
            designerPanelControlsInactiveBck: designerTheme.screen.feature.button.unselectedState.backgroundColor,
            designerPanelControlsInactiveContent: designerTheme.screen.feature.button.unselectedState.text.color,
            fontType: designerTheme.viewer3d.price.fontType
        };
    };
    DesignerTheme.basicProfileToTheme = function (sourceDesignerThemeBasicProfile) {
        var hexToRgbA = function (hex, transparency) {
            var c;
            if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
                c = hex.substring(1).split('');
                if (c.length == 3) {
                    c = [c[0], c[0], c[1], c[1], c[2], c[2]];
                }
                c = '0x' + c.join('');
                return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + transparency + ')';
            }
            throw new Error('Bad Hex');
        };
        var computeDesignerPanelControlsInactiveBck = function (designerPanelControlsInactiveBck, designerPanelBck) {
            if (designerPanelControlsInactiveBck === undefined) {
                /* Compute the inactive control background color based on the transparency rule - 50% white. Exception when background is white. */
                return designerPanelBck.toLowerCase() === '#ffffff' ? '#cccccc' : hexToRgbA('#ffffff', 0.5);
            }
            else {
                return designerPanelControlsInactiveBck;
            }
        };
        var designerThemeBasicProfile = __assign(__assign({}, sourceDesignerThemeBasicProfile), { designerPanelControlsInactiveBck: computeDesignerPanelControlsInactiveBck(sourceDesignerThemeBasicProfile.designerPanelControlsInactiveBck, sourceDesignerThemeBasicProfile.designerPanelBck) });
        if (designerThemeBasicProfile.designerPanelControlsInactiveBck === undefined) {
            /* Compute the inactive control background color based on the transparency rule - 50% white. Exception when background is white. */
            designerThemeBasicProfile.designerPanelControlsInactiveBck =
                designerThemeBasicProfile.designerPanelBck.toLowerCase() === '#ffffff'
                    ? '#cccccc'
                    : hexToRgbA('#ffffff', 0.5);
        }
        return {
            panelBackgroundColor: designerThemeBasicProfile.overallDesignerBck,
            progressOverlay: {
                backgroundColor: designerThemeBasicProfile.designerPanelBck,
                progressColor: designerThemeBasicProfile.designerPanelContent,
                textColor: designerThemeBasicProfile.designerPanelContent
            },
            notification: {
                addToCartFinished: {
                    success: {
                        icon: {
                            url: 'url_to_svg',
                            color: designerThemeBasicProfile.overallDesignerContent,
                            scaling: 1
                        },
                        text: {
                            color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                            fontType: designerThemeBasicProfile.fontType,
                            fontSize: 15
                        }
                    },
                    failure: {
                        icon: {
                            url: 'url_to_svg',
                            color: designerThemeBasicProfile.overallDesignerContent,
                            scaling: 1
                        },
                        text: {
                            color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                            fontType: designerThemeBasicProfile.fontType,
                            fontSize: 15
                        }
                    }
                },
                deviceRequiresOrientationChange: {
                    success: {
                        icon: {
                            url: 'url_to_svg',
                            color: designerThemeBasicProfile.overallDesignerContent,
                            scaling: 1
                        },
                        text: {
                            color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                            fontType: designerThemeBasicProfile.fontType,
                            fontSize: 15
                        }
                    },
                    failure: {
                        icon: {
                            url: 'url_to_svg',
                            color: designerThemeBasicProfile.overallDesignerContent,
                            scaling: 1
                        },
                        text: {
                            color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                            fontType: designerThemeBasicProfile.fontType,
                            fontSize: 15
                        }
                    }
                }
            },
            viewer3d: {
                panelBackgroundColor: designerThemeBasicProfile.overallDesignerBck,
                price: {
                    color: designerThemeBasicProfile.overallDesignerContent,
                    fontType: designerThemeBasicProfile.fontType,
                    fontSize: 18
                },
                fullScreenButton: {
                    unselectedState: {
                        backgroundColor: designerThemeBasicProfile.overallDesignerBck,
                        vector: {
                            url: 'url_to_svg',
                            color: designerThemeBasicProfile.overallDesignerContent,
                            scaling: 1
                        }
                    },
                    selectedState: {
                        backgroundColor: designerThemeBasicProfile.overallDesignerBck,
                        vector: {
                            url: 'url_to_svg',
                            color: designerThemeBasicProfile.overallDesignerContent,
                            scaling: 1
                        }
                    }
                }
            },
            screen: {
                fullscreen: {
                    button: {
                        unselectedState: {
                            backgroundColor: designerThemeBasicProfile.overallDesignerBck,
                            vector: {
                                url: 'url_to_svg',
                                color: designerThemeBasicProfile.overallDesignerContent,
                                scaling: 1
                            }
                        },
                        selectedState: {
                            backgroundColor: designerThemeBasicProfile.overallDesignerBck,
                            vector: {
                                url: 'url_to_svg',
                                color: designerThemeBasicProfile.overallDesignerContent,
                                scaling: 1
                            }
                        }
                    }
                },
                homeAccordion: {
                    panelBackgroundColor: designerThemeBasicProfile.designerPanelBck,
                    panelToggleButton: {
                        unselectedState: {
                            backgroundColor: designerThemeBasicProfile.designerPanelBck,
                            vector: {
                                url: 'url_to_svg',
                                color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                                scaling: 1
                            }
                        },
                        selectedState: {
                            backgroundColor: designerThemeBasicProfile.designerPanelBck,
                            vector: {
                                url: 'url_to_svg',
                                color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                                scaling: 1
                            }
                        }
                    },
                    addToCartButton: {
                        unselectedState: {
                            backgroundColor: designerThemeBasicProfile.designerPanelControlsInactiveBck,
                            text: {
                                color: designerThemeBasicProfile.designerPanelControlsInactiveContent,
                                fontType: designerThemeBasicProfile.fontType,
                                fontSize: 10
                            }
                        },
                        selectedState: {
                            backgroundColor: designerThemeBasicProfile.designerPanelControlsActiveBck,
                            text: {
                                color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                                fontType: designerThemeBasicProfile.fontType,
                                fontSize: 10
                            }
                        }
                    }
                },
                home: {
                    panelBackgroundColor: designerThemeBasicProfile.designerPanelBck,
                    configurationButton: {
                        unselectedState: {
                            backgroundColor: designerThemeBasicProfile.designerPanelControlsInactiveBck,
                            vector: {
                                url: 'url_to_svg',
                                color: designerThemeBasicProfile.designerPanelControlsInactiveContent,
                                scaling: 1
                            }
                        },
                        selectedState: {
                            backgroundColor: designerThemeBasicProfile.designerPanelControlsActiveBck,
                            vector: {
                                url: 'url_to_svg',
                                color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                                scaling: 1
                            }
                        },
                        caption: {
                            color: designerThemeBasicProfile.designerPanelContent,
                            fontType: designerThemeBasicProfile.fontType,
                            fontSize: 18
                        }
                    },
                    addToCartButton: {
                        unselectedState: {
                            backgroundColor: designerThemeBasicProfile.designerPanelControlsInactiveBck,
                            text: {
                                color: designerThemeBasicProfile.designerPanelControlsInactiveContent,
                                fontType: designerThemeBasicProfile.fontType,
                                fontSize: 10
                            }
                        },
                        selectedState: {
                            backgroundColor: designerThemeBasicProfile.designerPanelControlsActiveBck,
                            text: {
                                color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                                fontType: designerThemeBasicProfile.fontType,
                                fontSize: 10
                            }
                        }
                    }
                },
                feature: {
                    panelBackgroundColor: designerThemeBasicProfile.designerPanelBck,
                    panelTitle: {
                        color: designerThemeBasicProfile.designerPanelContent,
                        fontType: designerThemeBasicProfile.fontType,
                        fontSize: 15
                    },
                    sectionTitle: {
                        color: designerThemeBasicProfile.designerPanelContent,
                        fontType: designerThemeBasicProfile.fontType,
                        fontSize: 12
                    },
                    subSectionTitle: {
                        color: designerThemeBasicProfile.designerPanelContent,
                        fontType: designerThemeBasicProfile.fontType,
                        fontSize: 7
                    },
                    description: {
                        color: designerThemeBasicProfile.designerPanelContent,
                        fontType: designerThemeBasicProfile.fontType,
                        fontSize: 5
                    },
                    readMoreLink: {
                        color: designerThemeBasicProfile.designerPanelContent,
                        fontType: designerThemeBasicProfile.fontType,
                        fontSize: 6
                    },
                    button: {
                        unselectedState: {
                            backgroundColor: designerThemeBasicProfile.designerPanelControlsInactiveBck,
                            vector: {
                                url: 'url_to_svg',
                                color: designerThemeBasicProfile.designerPanelControlsInactiveContent,
                                scaling: 1
                            },
                            text: {
                                color: designerThemeBasicProfile.designerPanelControlsInactiveContent,
                                fontType: designerThemeBasicProfile.fontType,
                                fontSize: 10
                            }
                        },
                        selectedState: {
                            backgroundColor: designerThemeBasicProfile.designerPanelControlsActiveBck,
                            vector: {
                                url: 'url_to_svg',
                                color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                                scaling: 1
                            },
                            text: {
                                color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                                fontType: designerThemeBasicProfile.fontType,
                                fontSize: 10
                            }
                        }
                    },
                    textArea: {
                        backgroundColor: designerThemeBasicProfile.designerPanelControlsInactiveBck,
                        textLineSeparatorColor: designerThemeBasicProfile.designerPanelBck,
                        text: {
                            color: designerThemeBasicProfile.designerPanelControlsInactiveContent,
                            fontType: designerThemeBasicProfile.fontType,
                            fontSize: 24
                        }
                    },
                    horizontalSlider: {
                        root: {
                            color: designerThemeBasicProfile.designerPanelControlsActiveBck
                        },
                        thumb: {
                            backgroundColor: designerThemeBasicProfile.designerPanelBck,
                            borderColor: designerThemeBasicProfile.designerPanelControlsActiveBck
                        }
                    },
                    horizontalRadioGroup: {
                        item: {
                            unselectedState: {
                                backgroundColor: designerThemeBasicProfile.designerPanelControlsInactiveBck,
                                vector: {
                                    url: 'url_to_svg',
                                    color: designerThemeBasicProfile.designerPanelControlsInactiveContent,
                                    scaling: 1
                                },
                                text: {
                                    color: designerThemeBasicProfile.designerPanelControlsInactiveContent,
                                    fontType: designerThemeBasicProfile.fontType,
                                    fontSize: 10
                                }
                            },
                            selectedState: {
                                backgroundColor: designerThemeBasicProfile.designerPanelControlsActiveBck,
                                vector: {
                                    url: 'url_to_svg',
                                    color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                                    scaling: 1
                                },
                                text: {
                                    color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                                    fontType: designerThemeBasicProfile.fontType,
                                    fontSize: 10
                                }
                            }
                        }
                    },
                    horizontalCarousel: {
                        item: {
                            unselectedState: {
                                backgroundColor: designerThemeBasicProfile.designerPanelControlsInactiveBck,
                                vector: {
                                    url: 'url_to_svg',
                                    color: designerThemeBasicProfile.designerPanelControlsInactiveContent,
                                    scaling: 1
                                },
                                text: {
                                    color: designerThemeBasicProfile.designerPanelControlsInactiveContent,
                                    fontType: designerThemeBasicProfile.fontType,
                                    fontSize: 10
                                }
                            },
                            selectedState: {
                                backgroundColor: designerThemeBasicProfile.designerPanelControlsActiveBck,
                                vector: {
                                    url: 'url_to_svg',
                                    color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                                    scaling: 1
                                },
                                text: {
                                    color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                                    fontType: designerThemeBasicProfile.fontType,
                                    fontSize: 10
                                }
                            }
                        }
                    },
                    horizontalDropdown: {
                        backgroundColor: designerThemeBasicProfile.designerPanelControlsActiveBck,
                        text: {
                            color: designerThemeBasicProfile.designerPanelControlsActiveContent,
                            fontType: designerThemeBasicProfile.fontType,
                            fontSize: 10
                        }
                    }
                }
            }
        };
    };
    return DesignerTheme;
}());
exports.DesignerTheme = DesignerTheme;
